import type { CompEvent } from '@/components/results/store-comp-results'
import type { SocketResultMessagePayloadSeedConfirmed } from '@/components/results/socket/seed-confirmed/models/index'
import { simpleClone } from '@/services/common-service-utils'

export function updateSeedConfirmed(
  compEvent: CompEvent,
  payload: SocketResultMessagePayloadSeedConfirmed
): CompEvent {
  // console.log('update seed confirmed', { compEvent, payload })

  const compEventInternal = simpleClone(compEvent)

  // update the seeding for each entry
  payload.entries.forEach((entry) => {
    const athlete = compEventInternal.entries![entry.athleteId.toString()]
    if (!athlete) {
      return
    }
    athlete.seeding.heatNo = entry.heatInfo.heatNo
    athlete.seeding.laneNo = entry.heatInfo.laneNo

    athlete.heatNoCheckedIn = entry.heatInfo.heatNoCheckedIn
    athlete.laneNoCheckedIn = entry.heatInfo.laneNoCheckedIn
  })

  return compEventInternal
}
